// extracted by mini-css-extract-plugin
export default {"container":"xVb3Yg","content-container":"biNhDO","action":"jU2ZqZ","title":"fPQ11c","content":"JT3aK0","copy-button":"DxH3px"};